export const insertPhoto = require("../assets/insert_photo.png");
export const PhoneIcon = require("../assets/phone.svg").default;
export const VideoIcon = require("../assets/video-cam.svg").default;
export const MoreVerticalIcon = require("../assets/more-vertical.svg").default;
export const ReadIcon = require("../assets/read.svg").default;
export const VideoCallIcon = require("../assets/VideoCall.svg").default;
export const CallRingingSound = require("../assets/CallRinging.mp3");
export const IncomingCallSound = require("../assets/IncomingCall.mp3");
